/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/addon/services/intl';
import type RemoveTeammateController from 'embercom/controllers/apps/app/settings/workspace/teammates/teammate/remove';
import type Transition from '@ember/routing/transition';
import ManageTeammatesRoute from 'embercom/routes/apps/app/settings/base/manage-teammates-route';
import { hash } from 'rsvp';
import { UNASSIGNED_ADMIN_ID } from 'embercom/models/admin';

export default class RemoveRoute extends ManageTeammatesRoute {
  @service declare permissionsMutatorService: $TSFixMe;
  @service declare appService: AppService;
  @service declare customerService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;

  analytics = {
    section: 'settings',
    place: 'teammate-remove',
  };

  async beforeModel() {
    await super.beforeModel(...arguments);
    let teammateId = (this.paramsFor('apps.app.settings.workspace.teammates.teammate') as $TSFixMe)
      .id;
    if (teammateId === this.appService.app.currentAdmin.id) {
      this.replaceWith('apps.app.settings.workspace.teammates.teammate.permissions', teammateId);
    }
    await this.customerService.ensureDataIsLoaded.perform();
  }

  model() {
    return hash({
      app: this.appService.app,
      teammate: this.modelFor('apps.app.settings.workspace.teammates.teammate'),
      reassignments: { conversations: UNASSIGNED_ADMIN_ID, teams: {} },
      annuallyContractedWithOveragesEnabled: this.annuallyContractedWithOveragesEnabled,
    });
  }

  resetController(
    controller: RemoveTeammateController,
    _isExiting: boolean,
    _transition: Transition,
  ) {
    super.resetController(controller, _isExiting, _transition);

    controller.selectionIsValid = false;
  }

  private get annuallyContractedWithOveragesEnabled() {
    return this.appService.app.canUseSeatOverages && this.appService.app.isSalesforceContracted;
  }
}
